import React, {
  memo, useCallback, useEffect, useRef, useState,
} from "react";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import { useDispatch } from "react-redux";
import removeParamsFormHash from "@utils/removeParamasFromHash";
import { IconChevronDown, IconChevronUp } from "@searchComponents/icons";
import { setFilter } from "../store/actions";
import styles from "../../../styles/components/filter.module.scss";

const FilterCardSelect = memo(({
  title, content, parentValue, selected,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const filterCard = useRef(null);
  const [arrowDirection, setArrowDirection] = useState("down");
  const [data, setData] = useState([]);
  const toggleFilter = () => {
    if ([...filterCard.current.classList].includes("active-filter")) {
      setArrowDirection("down");
      setTimeout(() => {
        filterCard.current.style.display = "block";
      }, 205);
    } else {
      setArrowDirection("up");
      setTimeout(() => {
        filterCard.current.style.display = "none";
      }, 205);
    }
    filterCard.current.classList.toggle("active-filter");
  };

  // selectorStyles object
  const customStyles = {
    option: (styles, state) => ({
      ...styles,
      cursor: "pointer",
    }),
    control: (styles) => ({
      ...styles,
      cursor: "pointer",
    }),
  };

  useEffect(() => {
    setData(selected);
  }, [selected]);

  const delay = () => new Promise((res) => {
    setTimeout(() => res(), 100);
  });

  const handleClick = useCallback(async (value, action) => {
    const activeItems = {};

    [...data, ...value].forEach((item) => {
      if (activeItems[item.value]) {
        activeItems[item.value] = { count: activeItems[item.value]?.count + 1, value: item.value };
      } else {
        activeItems[item.value] = { count: 1, value: item.value };
      }
    });

    const activeItem = Object.values(activeItems) ? Object.values(activeItems).find((el) => el.count < 2) : {};

    if (action.action === "remove-value") {
      dispatch(setFilter(removeParamsFormHash(history.location.hash.replace("#", ""), activeItem.value), true));
    }

    if (action.action === "select-option") {
      dispatch(setFilter(`${parentValue}=${activeItem.value}`));
    }

    /**
         * TODO fix clear action in react-select
         if (action.action === "clear") {
        for (const item of data) {
          dispatch(setFilter(removeParamsFormHash(history.location.hash.replace("#", ""), item.value), true));
          await delay();
        }
      }
         */
  }, [data]);

  return (
        <div className={styles.card}>
            <div className={styles.bar} onClick={toggleFilter}>
                <p className={styles.title}>{title}</p>
                {arrowDirection === "down"
                  ? <IconChevronDown/>
                  : <IconChevronUp/>
                }
            </div>
            <div ref={filterCard} className={styles.content}>
                {/* <div className="filter__card-title">{ title }</div>
      <div className="filter__card-content"> */}
                <div className={styles.inner}>
                    <Select
                        menuPlacement="auto"
                        styles={customStyles}
                        classNamePrefix={styles.select}
                        className="filter__card-select"
                        isMulti
                        backspaceRemovesValue={true}
                        options={content.map(({ label, value }) => ({ value, label }))}
                        isClearable={false}
                        placeholder={`${title}`}
                        // components={{ MultiValueLabel }}
                        value={selected}
                        onChange={(value, action) => handleClick(value, action)}
                    />
                    {/* {console.log(selected)} */}
                </div>
            </div>
        </div>
  );
});

export default FilterCardSelect;
